import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/patientConditionReport";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientConditionReport: {
		id: "form.patient_condition_report",
		defaultMessage: "Állapotváltozás jelentés"
	},
	description: {
		id: "form.patient_condition.description",
		defaultMessage: "Állapotváltozás leírása"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "patientConditionReport",
	value: {
		title: messages.patientConditionReport,
		validator,
		fieldset,
		showAttachments: false,
		applyCurrentDate: true,
		showTimeInput: true,
		returnTo: "status-history"
	}
};
